var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 7.75C11.6484 7.75 12.25 8.35156 12.25 9.0625V13.4375C12.25 14.1758 11.6484 14.75 10.9375 14.75H1.3125C0.574219 14.75 0 14.1758 0 13.4375V9.0625C0 8.35156 0.574219 7.75 1.3125 7.75H1.96875V4.96094C1.96875 2.66406 3.80078 0.777344 6.09766 0.75C8.39453 0.75 10.2812 2.60938 10.2812 4.90625V5.34375C10.2812 5.72656 9.98047 6 9.625 6H8.75C8.36719 6 8.09375 5.72656 8.09375 5.34375V4.90625C8.09375 3.83984 7.19141 2.9375 6.09766 2.9375C5.00391 2.96484 4.15625 3.86719 4.15625 4.93359V7.75H10.9375ZM7.21875 11.9062V10.5938C7.21875 9.99219 6.72656 9.5 6.125 9.5C5.49609 9.5 5.03125 9.99219 5.03125 10.5938V11.9062C5.03125 12.5352 5.49609 13 6.125 13C6.72656 13 7.21875 12.5352 7.21875 11.9062Z",
    fill: "#478F96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.9ce53b7c5e6675c2d24fa3dd6066fb81.svg";
export { ForwardRef as ReactComponent };